import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { CompanyContextService } from '../../layouts/main-layout/services/company-context.service';
import { catchError, map, of } from 'rxjs';

export const companyGuard: CanActivateFn = (route) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const companyContextService = inject(CompanyContextService);
  const companyCode = route.paramMap.get('companyCode');
  const lang = route.parent?.paramMap.get('lang') ?? 'es';

  if (!companyCode) {
    return router.createUrlTree([`/${lang}/select-company`]);
  }

  const company = userService.findCompanyByCode(companyCode);

  if (!company) {
    return router.createUrlTree([`/${lang}/select-company`]);
  }

  userService.selectCompany(company);

  return companyContextService.fetchPermissions().pipe(
    map(() => true),
    catchError(() => of(router.createUrlTree([`/${lang}/select-company`])))
  );
};
